/**
 * Textes juridiques (chantier C27) — une seule version pour le trio
 * mentions légales / conditions d'utilisation / confidentialité.
 *
 * `LEGAL_VERSION` est portée par les trois pages statiques de `public/` (ligne
 * « Version AAAA-MM-JJ ») et par `UserProfile.consentements.version` : un profil
 * dont la version est absente ou ancienne revoit la porte de consentement
 * (`ShellSwitch`), et le serveur n'accepte que la version courante
 * (`PUT /api/users/me/consentements`).
 *
 * Ce fichier vit dans src/constants/ (client) et est COPIÉ octet pour octet
 * dans api/src/constants/legal.ts (test de dérive `legal.drift.test.ts`) :
 * modifier ici, puis recopier. Monter la version quand un changement compte
 * pour la personne (nouveau destinataire, nouvelle finalité, nouvelle règle).
 */
export const LEGAL_VERSION = '2026-10-27';

/** Chemins des trois pages, lisibles sans compte. */
export const PAGES_LEGALES = {
  mentionsLegales: '/mentions-legales.html',
  conditions: '/conditions.html',
  confidentialite: '/confidentialite.html',
} as const;

/** Les pages, dans l'ordre où elles se lisent au pied d'un écran. */
export const LIENS_LEGAUX: ReadonlyArray<{ href: string; libelle: string }> = [
  { href: PAGES_LEGALES.mentionsLegales, libelle: 'Mentions légales' },
  { href: PAGES_LEGALES.conditions, libelle: "Conditions d'utilisation" },
  { href: PAGES_LEGALES.confidentialite, libelle: 'Confidentialité' },
];

/** Forme d'un consentement enregistré sur le profil (client et serveur). */
export interface Consentements {
  /** Version des textes acceptés (`LEGAL_VERSION` au moment de l'accord). */
  version: string;
  /** Date de l'accord (ISO côté client, Date côté serveur). */
  acceptedAt: string | Date;
  /** Case « mes notes peuvent contenir des opinions personnelles » cochée (RGPD art. 9). */
  contenusSensibles: boolean;
}

/** Le consentement porté par un profil est-il celui des textes courants ? */
export function consentementAJour(consentements: Partial<Consentements> | null | undefined): boolean {
  return !!consentements && consentements.version === LEGAL_VERSION && consentements.contenusSensibles === true;
}
